import React from 'react';
import './Portraits.css';

import Portrait from './Portrait.js';

const portraits = ( props ) => {
	
	return (
		<div className="People">
			{
				props.list.map( person => (
					<Portrait key={ person.id } { ...person } />
				))
			}
		</div>
	);
};

export default portraits;



// WEBPACK FOOTER //
// ./src/components/Portraits/Portraits.js